import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const informationField: AnswerPathTreeNode = { path: 'informationField', nodeId: NodeIds.informationField };
